import Vue from 'vue';
import { getInstance } from '@/_kk_wallet_relock/plugins/vue';
import { Web3Provider } from '@ethersproject/providers';
import { Contract } from '@ethersproject/contracts';
import { getAddress } from '@ethersproject/address';
//import {formatBytes32String,toUtf8Bytes} from "@ethersproject/strings";
//import { multicall } from '@bonustrack/snapshot.js/src/utils';
import utils from "web3-utils"
import store from '@/store';
import abi from '@/helpers/abi';
import config from '@/helpers/config';
import wsProvider from '@/helpers/ws';
import rpcProvider from '@/helpers/rpc';
import '@ethersproject/units';
import { parseEther,formatEther } from '@ethersproject/units';
import {parseUnits,formatUnits} from "@ethersproject/units";
import { values } from 'lodash';
// import { OpenSeaPort, Network } from 'opensea-js'
//import {rp} from "request-promise";

//const rp = import('request-promise');

let auth;
let web3;


const NTFS_1155_TOKEN_ABI = '[{"inputs":[{"internalType":"address","name":"_proxyRegistryAddress","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_owner","type":"address"},{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":false,"internalType":"bool","name":"_approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":true,"internalType":"address","name":"_from","type":"address"},{"indexed":true,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"indexed":false,"internalType":"uint256[]","name":"_amounts","type":"uint256[]"}],"name":"TransferBatch","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":true,"internalType":"address","name":"_from","type":"address"},{"indexed":true,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256","name":"_id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"TransferSingle","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"_uri","type":"string"},{"indexed":true,"internalType":"uint256","name":"_id","type":"uint256"}],"name":"URI","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"WhitelistAdminAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"WhitelistAdminRemoved","type":"event"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addWhitelistAdmin","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address[]","name":"_owners","type":"address[]"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"}],"name":"balanceOfBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"contractURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"_maxSupply","type":"uint256"},{"internalType":"uint256","name":"_initialSupply","type":"uint256"},{"internalType":"string","name":"_uri","type":"string"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"create","outputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"creators","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"address","name":"_operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"isOperator","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isWhitelistAdmin","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"},{"internalType":"uint256","name":"_quantity","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"mint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"removeMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"removeWhitelistAdmin","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceWhitelistAdmin","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_from","type":"address"},{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"internalType":"uint256[]","name":"_amounts","type":"uint256[]"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeBatchTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_from","type":"address"},{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"bool","name":"_approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"_newBaseMetadataURI","type":"string"}],"name":"setBaseMetadataURI","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"_interfaceID","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenMaxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"uri","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"}]';

const NTFS_721_TOKEN_ABI = '[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"GovernanceTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_governance","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"_minters","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"minter","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"minter","type":"address"}],"name":"removeMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeMint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeMint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"governance","type":"address"}],"name":"setGovernance","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"tokensOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'



//bnb-test
// const TransferProxy_ADDRESS = '0x10702bEbD7d15507F4Ed2078bC76da44D3BeF060';
// const ERC20TransferProxy_ADDRESS  = '0x960Af5485F41cA584513308af848b16477f276BD';
// const EXCHANGE_ADDRESS = '0x3386eFC541C6936f05b39bFa7078805f66d76Ea8'

//bnb
const TransferProxy_ADDRESS = '0x6961772CB0BE021caDfACF5Fd4a335DBb6deFA92';
const ERC20TransferProxy_ADDRESS  = '0x2b0037252ebD26f60F3c1CEC44d35cCd12CF811a';
const EXCHANGE_ADDRESS = '0x265567f7306516F4133060F723B5eAf1eF12A33f'


const EXCHANGE_ABI = '[{"inputs":[{"internalType":"contract TransferProxy","name":"_transferProxy","type":"address"},{"internalType":"contract TransferProxyForDeprecated","name":"_transferProxyForDeprecated","type":"address"},{"internalType":"contract ERC20TransferProxy","name":"_erc20TransferProxy","type":"address"},{"internalType":"contract ExchangeStateV1","name":"_state","type":"address"},{"internalType":"contract ExchangeOrdersHolderV1","name":"_ordersHolder","type":"address"},{"internalType":"address payable","name":"_beneficiary","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sellToken","type":"address"},{"indexed":true,"internalType":"uint256","name":"sellTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"sellValue","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"address","name":"buyToken","type":"address"},{"indexed":false,"internalType":"uint256","name":"buyTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"buyValue","type":"uint256"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"salt","type":"uint256"}],"name":"Buy","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sellToken","type":"address"},{"indexed":true,"internalType":"uint256","name":"sellTokenId","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"address","name":"buyToken","type":"address"},{"indexed":false,"internalType":"uint256","name":"buyTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"salt","type":"uint256"}],"name":"Cancel","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"constant":true,"inputs":[],"name":"beneficiary","outputs":[{"internalType":"address payable","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"components":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"salt","type":"uint256"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"sellAsset","type":"tuple"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"buyAsset","type":"tuple"}],"internalType":"struct ExchangeDomainV1.OrderKey","name":"key","type":"tuple"}],"name":"cancel","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"erc20TransferProxy","outputs":[{"internalType":"contract ERC20TransferProxy","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"components":[{"components":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"salt","type":"uint256"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"sellAsset","type":"tuple"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"buyAsset","type":"tuple"}],"internalType":"struct ExchangeDomainV1.OrderKey","name":"key","type":"tuple"},{"internalType":"uint256","name":"selling","type":"uint256"},{"internalType":"uint256","name":"buying","type":"uint256"},{"internalType":"uint256","name":"sellerFee","type":"uint256"}],"internalType":"struct ExchangeDomainV1.Order","name":"order","type":"tuple"},{"components":[{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"internalType":"struct ExchangeDomainV1.Sig","name":"sig","type":"tuple"},{"internalType":"uint256","name":"buyerFee","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"buyer","type":"address"}],"name":"exchange","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"ordersHolder","outputs":[{"internalType":"contract ExchangeOrdersHolderV1","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"components":[{"components":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"salt","type":"uint256"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"sellAsset","type":"tuple"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"buyAsset","type":"tuple"}],"internalType":"struct ExchangeDomainV1.OrderKey","name":"key","type":"tuple"},{"internalType":"uint256","name":"selling","type":"uint256"},{"internalType":"uint256","name":"buying","type":"uint256"},{"internalType":"uint256","name":"sellerFee","type":"uint256"}],"internalType":"struct ExchangeDomainV1.Order","name":"order","type":"tuple"},{"internalType":"uint256","name":"fee","type":"uint256"}],"name":"prepareBuyerFeeMessage","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":true,"inputs":[{"components":[{"components":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"salt","type":"uint256"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"sellAsset","type":"tuple"},{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"enum ExchangeDomainV1.AssetType","name":"assetType","type":"uint8"}],"internalType":"struct ExchangeDomainV1.Asset","name":"buyAsset","type":"tuple"}],"internalType":"struct ExchangeDomainV1.OrderKey","name":"key","type":"tuple"},{"internalType":"uint256","name":"selling","type":"uint256"},{"internalType":"uint256","name":"buying","type":"uint256"},{"internalType":"uint256","name":"sellerFee","type":"uint256"}],"internalType":"struct ExchangeDomainV1.Order","name":"order","type":"tuple"}],"name":"prepareMessage","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"pure","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address payable","name":"newBeneficiary","type":"address"}],"name":"setBeneficiary","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"state","outputs":[{"internalType":"contract ExchangeStateV1","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"transferProxy","outputs":[{"internalType":"contract TransferProxy","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"transferProxyForDeprecated","outputs":[{"internalType":"contract TransferProxyForDeprecated","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}]'



//bnb-test
// const WBNB_ADDRESS = '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd'
//bnb
const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
const WBNB_ABI = '[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"guy","type":"address"},{"name":"wad","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"src","type":"address"},{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"wad","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"dst","type":"address"},{"name":"wad","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"deposit","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"guy","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"dst","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"src","type":"address"},{"indexed":false,"name":"wad","type":"uint256"}],"name":"Withdrawal","type":"event"}]'


//jgn bnb
const AXIS_ADDRESS = '0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75';

//jgn bnb-test
// const AXIS_ADDRESS = '0xd8a3a9435a7EbF1dEb702A7A0A83561f9EcCEF57'

const AXIS_ABI = '[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"PauserAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"PauserRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"constant":true,"inputs":[],"name":"INITIAL_SUPPLY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addPauser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isPauser","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renouncePauser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'

//jgn bnb
const USDT_ADDRESS = '0xC13B7a43223BB9Bf4B69BD68Ab20ca1B79d81C75';

//jgn bnb-test
// const USDT_ADDRESS = '0xd8a3a9435a7EbF1dEb702A7A0A83561f9EcCEF57'

const USDT_ABI = '[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_upgradedAddress","type":"address"}],"name":"deprecate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"deprecated","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_evilUser","type":"address"}],"name":"addBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"upgradedAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balances","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"maximumFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_maker","type":"address"}],"name":"getBlackListStatus","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowed","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"who","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newBasisPoints","type":"uint256"},{"name":"newMaxFee","type":"uint256"}],"name":"setParams","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"issue","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"redeem","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"basisPointsRate","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"isBlackListed","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_clearedUser","type":"address"}],"name":"removeBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MAX_UINT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_blackListedUser","type":"address"}],"name":"destroyBlackFunds","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"_initialSupply","type":"uint256"},{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_decimals","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Issue","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Redeem","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"newAddress","type":"address"}],"name":"Deprecate","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"feeBasisPoints","type":"uint256"},{"indexed":false,"name":"maxFee","type":"uint256"}],"name":"Params","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_blackListedUser","type":"address"},{"indexed":false,"name":"_balance","type":"uint256"}],"name":"DestroyedBlackFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"AddedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"RemovedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"}]';

const CAKE_ADDRESS = '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82'


const NFT_FEE = 250



//bnb-test
// const NFT1155_MINT_ADDRESS = '0x2a86186F634f5f6764Cb5fc66f5cF615f881a3a3'
// const NFT721_MINT_ADDRESS = '0xCD80A5385019B593af41f45a18488CCD5b2d1Ee0'

//bnb
const NFT721_MINT_ADDRESS = '0x3e855B7941fE8ef5F07DAd68C5140D6a3EC1b286'
const NFT1155_MINT_ADDRESS = '0x3E31F70912c00AEa971A8b2045bd568D738C31Dc'

const NFT1155_MINT_ABI = '[{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"address","name":"signer","type":"address"},{"internalType":"string","name":"contractURI","type":"string"},{"internalType":"string","name":"tokenURIPrefix","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_owner","type":"address"},{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":false,"internalType":"bool","name":"_approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"address[]","name":"recipients","type":"address[]"},{"indexed":false,"internalType":"uint256[]","name":"bps","type":"uint256[]"}],"name":"SecondarySaleFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"SignerAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"SignerRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":true,"internalType":"address","name":"_from","type":"address"},{"indexed":true,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"indexed":false,"internalType":"uint256[]","name":"_values","type":"uint256[]"}],"name":"TransferBatch","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"_operator","type":"address"},{"indexed":true,"internalType":"address","name":"_from","type":"address"},{"indexed":true,"internalType":"address","name":"_to","type":"address"},{"indexed":false,"internalType":"uint256","name":"_id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_value","type":"uint256"}],"name":"TransferSingle","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"_value","type":"string"},{"indexed":true,"internalType":"uint256","name":"_id","type":"uint256"}],"name":"URI","type":"event"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addSigner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address[]","name":"_owners","type":"address[]"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"}],"name":"balanceOfBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"},{"internalType":"uint256","name":"_value","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"contractURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"creators","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"fees","outputs":[{"internalType":"address payable","name":"recipient","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getFeeBps","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getFeeRecipients","outputs":[{"internalType":"address payable[]","name":"","type":"address[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"address","name":"_operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isSigner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"components":[{"internalType":"address payable","name":"recipient","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"internalType":"struct ERC1155Base.Fee[]","name":"fees","type":"tuple[]"},{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"string","name":"uri","type":"string"}],"name":"mint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"removeSigner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceSigner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_from","type":"address"},{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"internalType":"uint256[]","name":"_values","type":"uint256[]"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeBatchTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_from","type":"address"},{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_id","type":"uint256"},{"internalType":"uint256","name":"_value","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_operator","type":"address"},{"internalType":"bool","name":"_approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"contractURI","type":"string"}],"name":"setContractURI","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"tokenURIPrefix","type":"string"}],"name":"setTokenURIPrefix","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"tokenURIPrefix","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"_id","type":"uint256"}],"name":"uri","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"}]'
const NFT721_MINT_ABI = '[{"inputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"string","name":"contractURI","type":"string"},{"internalType":"string","name":"tokenURIPrefix","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"address[]","name":"recipients","type":"address[]"},{"indexed":false,"internalType":"uint256[]","name":"bps","type":"uint256[]"}],"name":"SecondarySaleFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"contractURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"fees","outputs":[{"internalType":"address payable","name":"recipient","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getFeeBps","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"name":"getFeeRecipients","outputs":[{"internalType":"address payable[]","name":"","type":"address[]"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"components":[{"internalType":"address payable","name":"recipient","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"internalType":"struct ERC721Base.Fee[]","name":"_fees","type":"tuple[]"},{"internalType":"string","name":"tokenURI","type":"string"}],"name":"mint","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"contractURI","type":"string"}],"name":"setContractURI","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"string","name":"tokenURIPrefix","type":"string"}],"name":"setTokenURIPrefix","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"tokenURIPrefix","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'




/*
wsProvider.on('block', blockNumber => {
  store.commit('GET_BLOCK_SUCCESS', blockNumber);
});
*/

const state = {
  injectedLoaded: false,
  injectedChainId: null,
  account: null,
  account_balance_eth: 0,
  account_balance_lp: 0,
  account_balance_dpo: '0',

  nft_address_single: NFT721_MINT_ADDRESS,
  nft_address_multi: NFT1155_MINT_ADDRESS,
  account_wallet: [
    {
      id: 'eth',
      name: 'BNB',
      names: {
        en: 'BNB',
        zh: '',
      },
      num: 0,
    },
    {
      id: 'weth',
      name: 'WBNB',
      names: {
        en: 'WBNB',
        zh: '',
      },
      num: 0,
    },
    {
      id: 'usdt',
      name: 'USDT',
      names: {
        en: 'USDT',
        zh: '',
      },
      num: 0,
    },
    {
      id: 'axis',
      name: 'JGN',
      names: {
        en: 'JGN',
        zh: '',
      },
      num: 0,
    },
    {
      id: 'cake',
      name: 'CAKE',
      names: {
        en: 'CAKE',
        zh: '',
      },
      num: 0,
    },
  ],
  current_block_num: 0,
  name: null,
  active: false,
  balances: {},
  blockNumber: 0,
  status_account_approved: false, //是否参与farm stake


};

// 
const mutations = {
  setWeb3Data(state,obj){
    for(let key in obj){
      state[key] = obj[key]
    }
  },
  setWeb3AccountWalletItem(state,obj){
    let item =state.account_wallet.find(item => obj.id == item.id)
    item.num = parseFloat(obj.num)
  },
  LOGOUT(_state) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'name', null);
    Vue.set(_state, 'active', false);
    Vue.set(_state, 'balances', {});
    console.debug('LOGOUT');
  },
  LOAD_WEB3_REQUEST() {
    console.debug('LOAD_WEB3_REQUEST');
  },
  LOAD_WEB3_SUCCESS() {
    console.debug('LOAD_WEB3_SUCCESS');
  },
  LOAD_WEB3_FAILURE(_state, payload) {
    console.debug('LOAD_WEB3_FAILURE', payload);
  },
  LOAD_PROVIDER_REQUEST() {
    console.debug('LOAD_PROVIDER_REQUEST');
  },
  LOAD_PROVIDER_SUCCESS(_state, payload) {
    Vue.set(_state, 'injectedLoaded', payload.injectedLoaded);
    Vue.set(_state, 'injectedChainId', payload.injectedChainId);
    Vue.set(_state, 'account', payload.account);
    Vue.set(_state, 'name', payload.name);
    console.debug('LOAD_PROVIDER_SUCCESS');
  },
  LOAD_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_PROVIDER_FAILURE', payload);
  },
  LOAD_BACKUP_PROVIDER_REQUEST() {
    console.debug('LOAD_BACKUP_PROVIDER_REQUEST');
  },
  LOAD_BACKUP_PROVIDER_SUCCESS(_state, payload) {
    console.debug('LOAD_BACKUP_PROVIDER_SUCCESS', payload);
  },
  LOAD_BACKUP_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'backUpLoaded', false);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'activeChainId', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_BACKUP_PROVIDER_FAILURE', payload);
  },
  HANDLE_CHAIN_CHANGED() {
    console.debug('HANDLE_CHAIN_CHANGED');
  },
  HANDLE_ACCOUNTS_CHANGED(_state, payload) {
    Vue.set(_state, 'account', payload);
    console.debug('HANDLE_ACCOUNTS_CHANGED', payload);
  },
  HANDLE_CLOSE_CHANGED() {
    console.debug('HANDLE_CLOSE_CHANGED');
  },
  HANDLE_NETWORK_CHANGED() {
    console.debug('HANDLE_NETWORK_CHANGED');
  },
  LOOKUP_ADDRESS_REQUEST() {
    console.debug('LOOKUP_ADDRESS_REQUEST');
  },
  LOOKUP_ADDRESS_SUCCESS(_state, payload) {
    Vue.set(_state, 'name', payload);
    console.debug('LOOKUP_ADDRESS_SUCCESS');
  },
  LOOKUP_ADDRESS_FAILURE(_state, payload) {
    console.debug('LOOKUP_ADDRESS_FAILURE', payload);
  },
  RESOLVE_NAME_REQUEST() {
    console.debug('RESOLVE_NAME_REQUEST');
  },
  RESOLVE_NAME_SUCCESS() {
    console.debug('RESOLVE_NAME_SUCCESS');
  },
  RESOLVE_NAME_FAILURE(_state, payload) {
    console.debug('RESOLVE_NAME_FAILURE', payload);
  },
  SEND_TRANSACTION_REQUEST() {
    console.debug('SEND_TRANSACTION_REQUEST');
  },
  SEND_TRANSACTION_SUCCESS() {
    console.debug('SEND_TRANSACTION_SUCCESS');
  },
  SEND_TRANSACTION_FAILURE(_state, payload) {
    console.debug('SEND_TRANSACTION_FAILURE', payload);
  },
  SIGN_MESSAGE_REQUEST() {
    console.debug('SIGN_MESSAGE_REQUEST');
  },
  SIGN_MESSAGE_SUCCESS() {
    console.debug('SIGN_MESSAGE_SUCCESS');
  },
  SIGN_MESSAGE_FAILURE(_state, payload) {
    console.debug('SIGN_MESSAGE_FAILURE', payload);
  },
  GET_BLOCK_REQUEST() {
    console.debug('GET_BLOCK_REQUEST');
  },
  GET_BLOCK_SUCCESS(_state, payload) {
    Vue.set(_state, 'blockNumber', payload);
    console.debug('GET_BLOCK_SUCCESS', payload);
  },
  GET_BLOCK_FAILURE(_state, payload) {
    console.debug('GET_BLOCK_FAILURE', payload);
  },
  METADATA_SUCCESS(_state, payload) {
    Vue.set(_state, 'spaces', payload);
    console.debug('METADATA_SUCCESS');
  }
};

// 
const actions = {
  login: async ({ dispatch }, connector = 'injected') => {
    console.log('into----web3.ts login()----')
    auth = getInstance();
    await auth.login(connector);
    if (auth.provider) {
      web3 = new Web3Provider(auth.provider);
      await dispatch('loadWeb3');
      
      // seaport覆盖只读的那个web3
      // const seaport = new OpenSeaPort(auth.provider, {
      //   networkName: Network.Main
      // })
      // window._seaport = seaport
      // console.log('_seaport with login done.')
    }
  },
  logout: async ({ commit }) => {
    Vue.prototype.$auth.logout();
    commit('LOGOUT');
  },
  loadWeb3: async ({ commit, dispatch }) => {
    commit('LOAD_WEB3_REQUEST');
    try {
      await dispatch('loadProvider');
      await dispatch('lookupAddress');
      commit('LOAD_WEB3_SUCCESS');
      if (!state.injectedLoaded || state.injectedChainId !== config.chainId) {
        await dispatch('loadBackupProvider');
      } else {
        /**
        this.providerStatus.activeChainId = this.providerStatus.injectedChainId;
        this.providerStatus.injectedActive = true;
        if (this.providerStatus.account)
          this.fetchUserBlockchainData(this.providerStatus.account);
        */
      }
    } catch (e) {
      commit('LOAD_WEB3_FAILURE', e);
      return Promise.reject();
    }
  },
  loadProvider: async ({ commit, dispatch }) => {
    commit('LOAD_PROVIDER_REQUEST');
    try {
      if (auth.provider.removeAllListeners) auth.provider.removeAllListeners();
      if (auth.provider.on) {
        auth.provider.on('chainChanged', async () => {
          commit('HANDLE_CHAIN_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('accountsChanged', async accounts => {
          if (accounts.length === 0) {
            if (state.active) await dispatch('loadWeb3');
          } else {
            commit('HANDLE_ACCOUNTS_CHANGED', accounts[0]);
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('disconnect', async () => {
          commit('HANDLE_CLOSE');
          if (state.active) await dispatch('loadWeb3');
        });
        auth.provider.on('networkChanged', async () => {
          commit('HANDLE_NETWORK_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
      }
      const network = await web3.getNetwork();
      const accounts = await web3.listAccounts();
      const account = accounts.length > 0 ? accounts[0] : null;
      commit('LOAD_PROVIDER_SUCCESS', {
        injectedLoaded: true,
        injectedChainId: network.chainId,
        account,
        name
      });
    } catch (e) {
      commit('LOAD_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  loadBackupProvider: async ({ commit }) => {
    try {
      web3 = rpcProvider;
      const network = await rpcProvider.getNetwork();
      commit('LOAD_BACKUP_PROVIDER_SUCCESS', {
        injectedActive: false,
        backUpLoaded: true,
        account: null,
        activeChainId: network.chainId
        // backUpWeb3: web3,
      });
    } catch (e) {
      commit('LOAD_BACKUP_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  lookupAddress: async ({ commit }) => {
    commit('LOOKUP_ADDRESS_REQUEST');
    try {
      const name = await web3.lookupAddress(state.account);
      commit('LOOKUP_ADDRESS_SUCCESS', name);
      return name;
    } catch (e) {
      commit('LOOKUP_ADDRESS_FAILURE', e);
    }
  },
  resolveName: async ({ commit }, payload) => {
    commit('RESOLVE_NAME_REQUEST');
    try {
      const address = await web3.resolveName(payload);
      commit('RESOLVE_NAME_SUCCESS');
      return address;
    } catch (e) {
      commit('RESOLVE_NAME_FAILURE', e);
      return Promise.reject();
    }
  },
  sendTransaction: async (
    { commit },
    [contractType, contractAddress, action, params]
  ) => {
    commit('SEND_TRANSACTION_REQUEST');
    try {
      const signer = web3.getSigner();
      const contract = new Contract(
        getAddress(contractAddress),
        abi[contractType],
        web3
      );
      const contractWithSigner = contract.connect(signer);
      const tx = await contractWithSigner[action](...params);
      await tx.wait();
      commit('SEND_TRANSACTION_SUCCESS');
      return tx;
    } catch (e) {
      commit('SEND_TRANSACTION_FAILURE', e);
      return Promise.reject();
    }
  },
  signMessage: async ({ commit }, message) => {
    commit('SIGN_MESSAGE_REQUEST');
    try {
      const signer = web3.getSigner();
      const sig = await signer.signMessage(message);
      commit('SIGN_MESSAGE_SUCCESS');
      return sig;
    } catch (e) {
      commit('SIGN_MESSAGE_FAILURE', e);
      return Promise.reject(e);
    }
  },
  getBlockNumber: async ({ commit }) => {
    commit('GET_BLOCK_REQUEST');
    try {
      const blockNumber: any = await rpcProvider.getBlockNumber();
      commit('GET_BLOCK_SUCCESS', parseInt(blockNumber));
      return blockNumber;
    } catch (e) {
      commit('GET_BLOCK_FAILURE', e);
      return Promise.reject();
    }
  },

  hasApproveCake: async ({ commit }, address) => {
    console.log('=== into === hasApproveCake',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(CAKE_ADDRESS, USDT_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,ERC20TransferProxy_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  approveCake: async (context,obj) => {
    console.log('=== into === approveCake')

    try {

      const signer = web3.getSigner();
      const lp_contract = new Contract(CAKE_ADDRESS, USDT_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      await lp_WithSigner.approve(ERC20TransferProxy_ADDRESS,parseUnits('1',36));
      
      if(obj && obj.callback){
        obj.callback()
      }
    }

    catch {

      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },

  getCakeBalance:async ({ commit }, address) => {
    console.log('=== into === getCakeBalance',address)
    const signer = web3.getSigner();
    const vaults_contract = new Contract(CAKE_ADDRESS, USDT_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(address);
    let b = formatUnits(b_num,18);
    return b;
  },

  hasApproveUSDT: async ({ commit }, address) => {
    console.log('=== into === hasApproveUSDT',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(USDT_ADDRESS, USDT_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,ERC20TransferProxy_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  approveUSDT: async (context,obj) => {
    console.log('=== into === approveUSDT')

    try {

      const signer = web3.getSigner();
      const lp_contract = new Contract(USDT_ADDRESS, USDT_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      await lp_WithSigner.approve(ERC20TransferProxy_ADDRESS,parseUnits('1',36));
      
      if(obj && obj.callback){
        obj.callback()
      }
    }

    catch {

      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },

  getUSDTBalance:async ({ commit }, address) => {
    console.log('=== into === getUSDTBalance',address)
    const signer = web3.getSigner();
    const vaults_contract = new Contract(USDT_ADDRESS, USDT_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(address);
    let b = formatUnits(b_num,6);
    return b;
  },


  hasApproveAXIS: async ({ commit }, address) => {
    console.log('=== into === hasApproveAXIS',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(AXIS_ADDRESS,AXIS_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,ERC20TransferProxy_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  approveAXIS: async (context,obj) => {
    console.log('=== into === approveAXIS')
    try {
      const signer = web3.getSigner();
      const lp_contract = new Contract(AXIS_ADDRESS,AXIS_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      await lp_WithSigner.approve(ERC20TransferProxy_ADDRESS,parseUnits('1',36));
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch {
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },

  hasApproveWBNB: async ({ commit }, address) => {
    console.log('=== into === hasApproveWBNB',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(WBNB_ADDRESS,WBNB_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,ERC20TransferProxy_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  approveWBNB: async (context,obj) => {
    console.log('=== into === approveWBNB')
    try {
      const signer = web3.getSigner();
      const lp_contract = new Contract(WBNB_ADDRESS,WBNB_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      await lp_WithSigner.approve(ERC20TransferProxy_ADDRESS,parseUnits('1',36));
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch {
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },


  getAXISBalance:async ({ commit }, address) => {
    console.log('=== into === getAXISBalance',address)
    const signer = web3.getSigner();
    const vaults_contract = new Contract(AXIS_ADDRESS, AXIS_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(address);
    let b = formatUnits(b_num,18);
    return b;
  },

  getETHBalance:async ({ commit }, address) => {
    console.log('=== into === getETHBalance',address)
    let b_num = await web3.getBalance(address);
    let b = formatEther(b_num);
    return b;
  },


  getWBNBBalance:async ({ commit }, address) => {
    console.log('=== into === getWBNBBalance',address)
    const signer = web3.getSigner();
    const vaults_contract = new Contract(WBNB_ADDRESS, WBNB_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(address);
    let b = formatUnits(b_num,18);
    return b;
  },

  fromBNBToWBNB: async (context,obj) => {
    console.log('=== into === fromBNBToWBNB',obj)
    console.log(obj)
    try {
      const {num} = obj
      console.log(num)
      let amount = parseEther(num+'');
      console.log(amount);
      // let sendNum = parseEther(num);
      const signer = web3.getSigner();
      const lp_contract = new Contract(WBNB_ADDRESS,WBNB_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);

      var tx = await lp_WithSigner.deposit({value:amount});

      
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);
  
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch (err1){
      console.log(err1)
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },

  //该地址是否已经同意了动用NFT来兑换奖品
  hasApproveNFT: async ({ commit }, obj) => {
    const {address,NTFS_TOKEN_ADDRESS,type} = obj

    console.log('=== into === hasApproveNFT',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.isApprovedForAll(address,TransferProxy_ADDRESS);
    console.log(b_num);
    if(b_num > 0){
      return true;
    }
    return false;
  },


  //同意动用NFT来兑换奖品
  approveNFT: async (context,obj) => {
    console.log('=== into === approveNFT')
    const {address,NTFS_TOKEN_ADDRESS,type} = obj


    try{

      const signer = web3.getSigner();
      const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      let res = await lp_WithSigner.setApprovalForAll(TransferProxy_ADDRESS,true);

      console.log('approve res:',res)
  
      // success callback
      if(obj&&obj.callback){
        obj.callback()
      }
    }
    catch{
      // err callback
      if(obj&&obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },


  approveNFTWithPending: async (context,obj) => {
    console.log('=== into === approveNFTWithPending')
    const {address,NTFS_TOKEN_ADDRESS,type} = obj

    try{
      const signer = web3.getSigner();
      const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      let tx = await lp_WithSigner.setApprovalForAll(TransferProxy_ADDRESS,true);
      // console.log('approve res:',res)
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);

      // success callback
      if(obj&&obj.callback){
        obj.callback()
      }
    }
    catch{
      // err callback
      if(obj&&obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },


  


  // //该地址是否拥有这个NFT
  // verifyNFTOwner: async ({ commit }, obj) => {
  //   const {address,NTFS_TOKEN_ADDRESS,NFT_ID,type} = obj
  //   console.log(obj)
  //   console.log('=== into === verifyNFTOwner',address)
  //   const signer = web3.getSigner();
  //   const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_TOKEN_ABI, web3);
  //   const lp_WithSigner = lp_contract.connect(signer);
  //   const b_num = await lp_WithSigner.balanceOf(address,NFT_ID);
  //   let b = parseInt(b_num);
  //   if(b > 0){
  //     return true;
  //   }
  //   return false;
  // },


  verifyNFTOwner: async ({ commit }, obj) => {
    const {address,NTFS_TOKEN_ADDRESS,NFT_ID,type} = obj
    console.log(obj)
    console.log('=== into === verifyNFTOwner',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    //0xd9b67a26 is 1155
    const b_num = await lp_WithSigner.supportsInterface('0xd9b67a26');
    
    if(b_num){
      //is 1155
      const b_num = await lp_WithSigner.balanceOf(address,NFT_ID);
      let b = parseInt(b_num);
      if(b > 0){
        return true;
      }
      return false;
    }
    else{
      //is 721
      const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_721_TOKEN_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      const b_num = await lp_WithSigner.ownerOf(NFT_ID);
      console.log(b_num)
      if(b_num.toLowerCase() == address.toLowerCase()){
        return true
      }
      return false;
    }

  },


  
  sellSignMessage: async ({ commit }, obj) => {
    console.log('=== into === sellSignMessage')

    // address 是登录的地址，price是传入的数量
    const {address,sell_price,sell_token_id,token_address,token_id,type,sign_str} = obj
    console.log(address,sell_price,sell_token_id,token_address,token_id,type,sign_str)


    var sellAssertType = 0
    if (type == '721') {
      sellAssertType = 3
    }
    else if(type == '1155'){
      sellAssertType = 2
    }

    var price = sell_price;
    var price_type = 0;
    var price_address = '';
    if (sell_token_id == 'eth') {
      price = parseEther(sell_price+'')
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(sell_token_id == 'axis'){
      price = parseUnits(sell_price+'',18)
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(sell_token_id == 'usdt'){
      price = parseUnits(sell_price+'',6)
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(sell_token_id == 'cake'){
      console.log('sell on cake')
      price = parseUnits(sell_price+'',18)
      price_type = 1
      price_address = CAKE_ADDRESS;
    }
    
    console.log(parseInt(price))

    
    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    
    var orderKey = {
      owner: address,
      salt: sign_str,
      sellAsset:{
          token:token_address,
          tokenId:token_id,
          assetType:sellAssertType
      },
      buyAsset:{
          token:price_address,
          tokenId:0,
          assetType:price_type
      }
    };

    var order = {
        key: orderKey,
        selling:1,
        buying:price,
        sellerFee:NFT_FEE,
    }
    console.log(order);

    var message = await lp_WithSigner.prepareMessage(order);
    console.log('message='+message+':'+ message.length);
    // const sig = await signer.signMessage(message);
    // console.log('sig='+sig+':'+ sig.length);
    // if(obj && obj.callback){
    //   obj.callback()
    // }
    // return sig

    try {
      const sig = await signer.signMessage(message);
      console.log('sig='+sig+':'+ sig.length);
      if(obj && obj.callback){
        obj.callback()
      }
      return sig
    } 
    catch {
      
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
      return null
    }

  },


  buyNFT: async ({ commit }, obj) => {

    console.log('=== into === buyNFT',obj)

    const {address,token_address,token_id,type,address_owner,salt,signature,buyValue,currency} = obj
    
    // var show_price = parseEther(buyValue+'')
    // console.log(parseInt(show_price));
    
    var sellAssertType = 0
    if (type == '721') {
      sellAssertType = 3
    }
    else if(type == '1155'){
      sellAssertType = 2
    }
    
    var price = buyValue;
    var price_type = 0;
    var price_address = '';
    if (currency == 'eth') {
      price = parseEther(buyValue+'')
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(currency == 'axis'){
      price = parseUnits(buyValue+'',18)
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(currency == 'usdt'){
      price = parseUnits(buyValue+'',6)
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(currency == 'cake'){
      price = parseUnits(buyValue+'',18)
      price_type = 1
      price_address = CAKE_ADDRESS;
    }

    var value_after;
    {
      var v2 = price.toString()
      var v3 = v2.substr(0,v2.length-3)
      var v4 = parseInt(v3)
      var v5 = parseInt(price) + 25 * v4
      value_after = v5.toString()
    }
    console.log(value_after)

    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    
    var orderKey = {
      owner: address_owner,
      salt: salt,
      sellAsset:{
          token:token_address,
          tokenId:token_id,
          assetType:sellAssertType
      },
      buyAsset:{
        token:price_address,
        tokenId:0,
        assetType:price_type
      }
    };

    var order = {
        key: orderKey,
        selling:1,
        buying:price,
        sellerFee:NFT_FEE,
    }

    console.log(order)

    //var sig = '0xb0e7045be56dd161e707e0099f4e6b805d188a2753cc912a00aa46c4dda6c2812262ab7a8f4835c9ed313d12b732afd729cce775aca674db862904bb381a56891c'
    var sig = signature

    var _r = '0x'+sig.substring(2, 66);
    //console.log('r='+r+':'+ r.length);
    var _s = '0x'+sig.substring(66,130);
    //console.log('s='+s+':'+ s.length);
    var _v = '0x'+sig.substring(130,132);
    //console.log('v='+v+':'+ v.length);

    var _sig = {
        v:parseInt(_v),
        r:utils.hexToBytes(_r),
        s:utils.hexToBytes(_s)
    }

    console.log(_sig);

    try{

      if(obj && obj.callHookOnBuy){
        obj.callHookOnBuy()
      }

      var tx;
      if (currency == 'eth') {
        console.log('send eth currency');
        tx = await lp_WithSigner.exchange(order,_sig,NFT_FEE,1,address,{value:value_after});
      }
      else {
        console.log('send other currency');
        tx = await lp_WithSigner.exchange(order,_sig,NFT_FEE,1,address);
      }
  
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);
  
      if(obj && obj.callback){
        obj.callback()
      }
  
      return transctions_hash
    }

    catch{
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
    
  },


  cancelSell: async ({ commit }, obj) => {
    console.log('=== into === cancelSell',obj)
    // const {address,sell_price,sell_token_id,token_address,token_id,type,sign_str} = obj
    // console.log(address,sell_price,sell_token_id,token_address,token_id,type,sign_str)
    const {address,token_address,token_id,type,address_owner,salt,signature,buyValue,currency} = obj

    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);


    var price_type = 0;
    var price_address = '';
    if (currency == 'eth') {
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(currency == 'axis'){
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(currency == 'usdt'){
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(currency == 'cake'){
      price_type = 1
      price_address = CAKE_ADDRESS;
    }

    
    var orderKey = {
      owner: address_owner,
      salt: salt,
      sellAsset:{
          token:token_address,
          tokenId:token_id,
          assetType:2
      },
      buyAsset:{
          token:price_address,
          tokenId:0,
          assetType:price_type
      }
    };

    try {
      var tx = await lp_WithSigner.cancel(orderKey);

      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);

      if(obj && obj.callback){
        obj.callback()
      }

    } catch (error) {

      console.log(error);

      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }

    }
    
  },


  accountSign: async ({ commit }, address) => {
    console.log('=== into === accountSign',address)
    var message = 'This is just extra security to ensure you own this wallet address:' + address
    const signer = web3.getSigner();
    const sig = await signer.signMessage(message);
    return sig
  },


  getCurrentBlockNumber: async ({ commit }) =>{
    var b = await web3.getBlockNumber()
    return b;
  },

  //
  nftBalance: async ({ commit }, obj) => {
    const {address,NTFS_TOKEN_ADDRESS,NFT_ID,type} = obj
    console.log(obj)
    console.log('=== into === nftBalance',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.balanceOf(address,NFT_ID);
    let b = parseInt(b_num);
    return b;
  },

  nftTransfer: async ({ commit }, obj) => {
    const {address,NTFS_TOKEN_ADDRESS,NFT_ID,type,to_address,num} = obj
    console.log(obj)
    console.log('=== into === nftTransfer',address)
    const signer = web3.getSigner();
    const lp_contract = new Contract(NTFS_TOKEN_ADDRESS, NTFS_1155_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    try{

      await lp_WithSigner.safeTransferFrom(address,to_address,NFT_ID,num,'0x0000000000000000000000000000000000000000');
  
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
  },

  NFT1155Mint: async ({ commit }, obj) => {
    const {address,NFT_ID,Royalties,supply,uri} = obj
    console.log(obj)
    console.log('=== into === NFT1155Mint')

    const signer = web3.getSigner();
    const lp_contract = new Contract(NFT1155_MINT_ADDRESS, NFT1155_MINT_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    try{
      var tx
      if(Royalties == 0){
        tx = await lp_WithSigner.mint(NFT_ID,[],supply,uri);
      }
      else{
        tx = await lp_WithSigner.mint(NFT_ID,[[address,Royalties*100]],supply,uri);
      }
      
  
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }

      
  },


  NFT721Mint: async ({ commit }, obj) => {
    const {address,NFT_ID,Royalties,uri} = obj
    console.log(obj)
    console.log('=== into === NFT721Mint')

    const signer = web3.getSigner();
    const lp_contract = new Contract(NFT721_MINT_ADDRESS, NFT721_MINT_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    
    try{
      var tx;
      if(Royalties == 0){
        tx = await lp_WithSigner.mint(NFT_ID,[],uri);
      }
      else{
        tx = await lp_WithSigner.mint(NFT_ID,[[address,Royalties*100]],uri);
      }
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);

      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{

      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
      
  },


  
  bidSignMessage: async ({ commit }, obj) => {
    console.log('=== into === bidSignMessage',obj)

    // address 是登录的地址，price是传入的数量
    const {address,bid_price,bid_token_id,token_address,token_id,type,sign_str} = obj
    console.log(address,bid_price,bid_token_id,token_address,token_id,type,sign_str)


    var buyAssertType = 0
    if (type == '721') {
      buyAssertType = 3
    }
    else if(type == '1155'){
      buyAssertType = 2
    }

    var price = bid_price;
    var price_type = 0;
    var price_address = '';
    if (bid_token_id == 'eth') {
      price = parseEther(bid_price+'')
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(bid_token_id == 'axis'){
      price = parseUnits(bid_price+'',18)
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(bid_token_id == 'usdt'){
      price = parseUnits(bid_price+'',6)
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(bid_token_id == 'weth'){
      price = parseUnits(bid_price+'',18)
      price_type = 1
      price_address = WBNB_ADDRESS;
    }
    else if(bid_token_id == 'cake'){
      price = parseUnits(bid_price+'',18)
      price_type = 1
      price_address = CAKE_ADDRESS;
    }
    
    console.log(parseInt(price))

    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    
    var orderKey = {
      owner: address,
      salt: sign_str,
      sellAsset:{
        token:price_address,
        tokenId:0,
        assetType:price_type
      },
      buyAsset:{
          token:token_address,
          tokenId:token_id,
          assetType:buyAssertType
      }
    };

    var order = {
        key: orderKey,
        selling:price,
        buying:1,
        sellerFee:NFT_FEE,
    }
    
    console.log(order);

    var message = await lp_WithSigner.prepareMessage(order);
    console.log('message='+message+':'+ message.length);

    try {
      const sig = await signer.signMessage(message);
      console.log('sig='+sig+':'+ sig.length);
      if(obj && obj.callback){
        obj.callback()
      }
      return sig
    } 
    catch {
      
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
      return null
    }
  },



  cancelBid: async ({ commit }, obj) => {
    //https://etherscan.io/tx/0x7bfc64e6abed8cfa02db433d88e07179603db7c6cdb8119999601b22e4f7721a#eventlog

    console.log('=== into === cancelBid',obj)
    
    const {address,token_address,token_id,type,address_owner,salt,signature,buyValue,currency} = obj

    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    var buyAssertType = 0
    if (type == '721') {
      buyAssertType = 3
    }
    else if(type == '1155'){
      buyAssertType = 2
    }

    var price_type = 0;
    var price_address = '';
    if (currency == 'eth') {
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(currency == 'axis'){
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(currency == 'usdt'){
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(currency == 'weth'){
      price_type = 1
      price_address = WBNB_ADDRESS;
    }
    else if(currency == 'cake'){
      price_type = 1
      price_address = CAKE_ADDRESS;
    }
    
    var orderKey = {
      owner: address,
      salt: salt,
      sellAsset:{
          token:price_address,
          tokenId:0,
          assetType:price_type
      },
      buyAsset:{
          token:token_address,
          tokenId:token_id,
          assetType:buyAssertType
      }
    };

    try {
      var tx = await lp_WithSigner.cancel(orderKey);

      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);

      if(obj && obj.callback){
        obj.callback()
      }

    } catch (error) {

      console.log(error);

      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }

    }
    
  },


  acceptBidNFT: async ({ commit }, obj) => {
    //https://etherscan.io/tx/0xb9d0cf6bf1ba5e1791364274df3e7bc5a00dc552e3299012d799faf06383fcdf
    console.log('=== into === acceptBidNFT',obj)

    const {address,token_address,token_id,type,address_owner,salt,signature,buyValue,currency} = obj

    
    var buyAssertType = 0
    if (type == '721') {
      buyAssertType = 3
    }
    else if(type == '1155'){
      buyAssertType = 2
    }
    
    var price = buyValue;
    var price_type = 0;
    var price_address = '';
    if (currency == 'eth') {
      price = parseEther(buyValue+'')
      price_type = 0
      price_address = '0x0000000000000000000000000000000000000000';
    }
    else if(currency == 'axis'){
      price = parseUnits(buyValue+'',18)
      price_type = 1
      price_address = AXIS_ADDRESS;
    }
    else if(currency == 'usdt'){
      price = parseUnits(buyValue+'',6)
      price_type = 1
      price_address = USDT_ADDRESS;
    }
    else if(currency == 'cake'){
      price = parseUnits(buyValue+'',18)
      price_type = 1
      price_address = CAKE_ADDRESS;
    }
    else if(currency == 'weth'){
      price = parseUnits(buyValue+'',18)
      price_type = 1
      price_address = WBNB_ADDRESS;
    }

    const signer = web3.getSigner();
    const lp_contract = new Contract(EXCHANGE_ADDRESS, EXCHANGE_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    
    var orderKey = {
      owner: address,
      salt: salt,
      sellAsset:{
        token:price_address,
        tokenId:0,
        assetType:price_type
      },
      buyAsset:{
        token:token_address,
        tokenId:token_id,
        assetType:buyAssertType
      }
    };

    var order = {
      key: orderKey,
      selling:price,
      buying:1,
      sellerFee:NFT_FEE,
    }


    console.log(order)

    //var sig = '0xb0e7045be56dd161e707e0099f4e6b805d188a2753cc912a00aa46c4dda6c2812262ab7a8f4835c9ed313d12b732afd729cce775aca674db862904bb381a56891c'
    var sig = signature

    var _r = '0x'+sig.substring(2, 66);
    //console.log('r='+r+':'+ r.length);
    var _s = '0x'+sig.substring(66,130);
    //console.log('s='+s+':'+ s.length);
    var _v = '0x'+sig.substring(130,132);
    //console.log('v='+v+':'+ v.length);

    var _sig = {
        v:parseInt(_v),
        r:utils.hexToBytes(_r),
        s:utils.hexToBytes(_s)
    }

    console.log(_sig);

    try{

      if(obj && obj.callHookOnBuy){
        obj.callHookOnBuy()
      }

      var tx;
      if (currency == 'eth') {
        console.log('send eth currency');
        // tx = await lp_WithSigner.exchange(order,_sig,NFT_FEE,1,address,{value:value_after});
      }
      else {
        console.log('send other currency');
        tx = await lp_WithSigner.exchange(order,_sig,NFT_FEE,price,address_owner);
      }
  
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      console.log(receipt);
      var transctions_hash = receipt.transactionHash
      console.log(transctions_hash);
  
      if(obj && obj.callback){
        obj.callback()
      }
  
      return transctions_hash
    }

    catch{
      if(obj && obj.callbackOnErr){
        obj.callbackOnErr()
      }
    }
    
  },


  metadata: async ({ commit }) => {
    // try {
    //   const noDecimals = ['yearn'];
    //   const response = await multicall(
    //     rpcProvider,
    //     abi['TestToken'],
    //     Object.values(spaces)
    //       .filter((space: any) => !noDecimals.includes(space.key))
    //       .map((space: any) => [space.address, 'decimals', []])
    //   );
    //   const payload = Object.fromEntries(
    //     response.map((item, i) => [
    //       // @ts-ignore
    //       Object.values(spaces).filter(
    //         (space: any) => !noDecimals.includes(space.key)
    //       )[i].address,
    //       { decimals: response[i][0] }
    //     ])
    //   );
    //   payload['0xBa37B002AbaFDd8E89a1995dA52740bbC013D992'] = { decimals: 18 };
    //   commit('METADATA_SUCCESS', payload);
    //   return payload;
    // } catch (e) {
    //   console.log(e);
    //   return Promise.reject();
    // }
  }
};

export default {
  state,
  mutations,
  actions
};
